module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_9006.307ea121.png";